import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-backoffice-login',
  templateUrl: './backoffice-login.component.html',
  styleUrls: ['./backoffice-login.component.css']
})
export class BackofficeLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    alert('omg');
  }

}
